<template>
  <div class="remastered-dialog">
    <slot name="before" />

    <div
      class="wrap"
      :class="{ blurred }"
      :style="dialogStyle"
    >
      <div class="headline">
        <slot
          v-if="$scopedSlots.title"
          name="title"
        />
        <span v-else>{{ title }}</span>
      </div>
      <div class="content">
        <slot />
      </div>
    </div>

    <slot name="after" />
  </div>
</template>

<script>
export default {
  name: 'RemasteredDialog',
  props: {
    title: {
      type: String,
      default: ''
    },
    blurred: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default: 490
    },
    height: {
      type: [Number, String],
      default: undefined
    }
  },
  computed: {
    dialogStyle () {
      const obj = {}
      if (this.width) {
        obj.width = this.width + 'px'
      }
      if (this.height) {
        obj.height = this.height + 'px'
      }
      return obj
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~css/addon/main'

.remastered-dialog {
  width: 100%
  height: 100%
  display: flex
  justify-content: center
  align-items: center
  position: absolute
  top: 0
  left: 0
  z-index: 9

  @media (max-width: $response-xs) {
    background: #FFF; // Prevent blurred black edge when blur effect active
  }
  >>> .el-button {
    display: flex
    justify-content: center
    align-items: center

    &:not(.is-disabled) {
      color: #FFF
      background: $pink-color
      border-color: $pink-color

      &:hover {
        background: rgba($pink-color, .75)
        border-color: rgba($pink-color, .75)
      }
      &:active {
        background: darken($pink-color, 20%)
        border-color: darken($pink-color, 20%)
      }
    }
  }
  a,
  >>> a,
  span,
  >>> span {
    color: inherit
    text-shadow: inherit
  }
}
.wrap {
  background: #FFF
  box-shadow: 0px 0px 50px rgba(#000, .5)
  filter: blur(0)
  position: relative
  border-radius: 15px
  transition: all .1s

  @media (max-width: $response-xs) {
    height: 100%
    width: 100%
    border-radius: 0
  }

  &.blurred {
    filter: saturate(.75) blur(2px)

    &:before {
      content: ''
      position: absolute
      top: 0
      left: 0
      width: 100%
      height: 100%
      z-index: 2
    }
  }
  .headline {
    padding: 25px 20px
    text-align: center
    font-size: 24px
    font-weight: bold
    color: #FFF
    background: linear-gradient(90deg, #DB3373 0%, #5E358C 100%)
    letter-spacing: 3px
    border-radius: 15px 15px 0 0

    @media (max-width: $response-xs) {
      padding-top: 40px
      padding-bottom: 40px
      border-radius: 0
    }
  }
  .content {
    padding: 40px

    @media (max-width: $response-xs) {
      padding: 50px 30px
    }
  }
}
</style>
